import {createContext, ReactNode, useCallback, useContext, useMemo, useState} from 'react'
import {createTheme, ThemeProvider as MuiThemeProvider} from '@mui/material/styles';
import {deDE as dataGridDeDE} from '@mui/x-data-grid/locales';
import {deDE as pickersDeDE} from '@mui/x-date-pickers/locales';
import {deDE as coreDeDE} from '@mui/material/locale';
import portalTheme from "./themes/PortalTheme";
import testamentTheme from "./themes/TestamentTheme";


interface ThemeContextType {
    themeMode: string
    setTheme: (theme: string) => void
}

const ThemeContext = createContext<ThemeContextType>({} as ThemeContextType)
const useThemeContext = () => useContext(ThemeContext)

interface Props {
    children: ReactNode
}

const SosThemeProvider = (props: Props) => {
    const [themeMode, setThemeMode] = useState("portal");


    const setTheme = useCallback((theme: string) => {
        let themename = "portal";
        if (theme === "start" || theme === "info" || theme === "uaa") {
            themename = "testament"
        }
        setThemeMode(themename)
        //  localStorage.setItem("theme", JSON.stringify(theme));
    }, [])

    function getTheme(themeMode: string) {
        if (themeMode === 'testament') {
            return createTheme(testamentTheme, dataGridDeDE, pickersDeDE, coreDeDE)
        } else {
            return createTheme(portalTheme, dataGridDeDE, pickersDeDE, coreDeDE, {
                typography: {
                    "fontFamily": `"HelveticaNeueLTStd-Bd", Helvetica, Arial, sans-serif`
                }
            });
        }
    }


    const contextValue = useMemo(() => ({
        themeMode,
        setTheme
    }), [themeMode, setTheme]);

    return (
        <ThemeContext.Provider value={contextValue}>
            <MuiThemeProvider theme={getTheme(themeMode)}>
                {props.children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    )
}


export {
    useThemeContext,
    SosThemeProvider
}